export const NOTIFICATION_DURATION: number = 2500;

// Short-IDs (22-char Base64URL encoded UUIDs) for API transport
export const BACKLOG_UID: string = 'j1jDC6AYSs-BMdYKSguYLA';
export const ISSUE_TYPE_MILESTONE: string = '9TLSWLtBSWiSBOxoQEq2kg';
export const ISSUE_TYPE_PUBLIC_HOLIDAY: string = 'CWlQ3b98SwuP2xdjqZxmGQ';
export const ISSUE_TYPE_VACATION: string = 'B-_8_OfURJGLGAswjdJQEw';
export const ISSUE_TYPE_MISCELLANEOUS: string = 'ZDTlPPgXSAaT5DD9mfLsnA';
export const ISSUE_TYPE_REMINDER: string = 'gAXXJO-PQ9qaGLA_szIZrA';
/** The five fixed root issue types (ToDo, Milestone, Absence, Public holiday, Reminder). */
export const ROOT_TYPE_UIDS: readonly string[] = [
    ISSUE_TYPE_MISCELLANEOUS, ISSUE_TYPE_MILESTONE, ISSUE_TYPE_VACATION, ISSUE_TYPE_PUBLIC_HOLIDAY, ISSUE_TYPE_REMINDER,
];
export const ISSUE_STATUS_OPEN: string = 'vUswBgwTQ1miIiAnCycEuQ';
export const ISSUE_STATUS_IN_PROGRESS: string = 'AZJOo0KeclSNR502iSVRpQ';
export const ISSUE_STATUS_DONE: string = '0onufF05Thu0Sl4J9G-mKw';
export const BOARD_TYPE_PROJECT: string = 'qqcASlXPTOG8LhIwliq35w';
export const BOARD_TYPE_DAILY: string = 'ASexeOVqS5eRO06njlEYZA';
export const CALENDAR_PROJECT_UID: string = 'CRLpgA5_TueEpRdKGAC4uA';
